import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authSlice";
// slices (calendar, chat, kanban, mail, product removed — template pages deleted)
// import mailReducer from "./slices/mail";
// import chatReducer from "./slices/chat";
// import productReducer from "./slices/product";
// import calendarReducer from "./slices/calendar";
// import kanbanReducer from "./slices/kanban";

// ----------------------------------------------------------------------

/**
 * Root persist configuration
 * - auth: Persists user, selectedRole, availableRoles, isAuthenticated
 *   This is the SINGLE SOURCE OF TRUTH for auth state (replaces scattered localStorage)
 * - user: Legacy key (kept for migration compatibility)
 *
 * NOTE: accessToken and refreshToken are still stored directly in localStorage
 * because axios interceptors need them before Redux hydrates on page load.
 */
export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: ["auth"], // auth slice is persisted; "user" removed (now part of auth.user)
};

// export const productPersistConfig = {
//   key: "product",
//   storage,
//   keyPrefix: "redux-",
//   whitelist: ["sortBy", "checkout"],
// };

const rootReducer = combineReducers({
  auth: authReducer,
  // mail: mailReducer,
  // chat: chatReducer,
  // calendar: calendarReducer,
  // kanban: kanbanReducer,
  // product: persistReducer(productPersistConfig, productReducer),
});

export default rootReducer;
